'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import attdAction from '../../actions/attdAction';
import attdStore from '../../stores/attdStore';
import userStore from '../../stores/userStore';
import genFunction from '../../functions/genFunction';

class AttdFilter extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onUserChange = this.onUserChange.bind(this);
        this.state = {
            search: attdStore.getState().search,

            permission: userStore.getState().permission,
            subordinate: userStore.getState().subordinate,
            userId: userStore.getState().staffId,
        }
    }

    componentDidMount() {
        attdStore.listen(this.onChange);
        userStore.listen(this.onUserChange);
    }
    componentWillUnmount() {
        attdStore.unlisten(this.onChange);
        userStore.unlisten(this.onUserChange);
    }
    onUserChange(state) {
        this.setState({
            permission: state.permission,
            subordinate: state.subordinate,
            userId: state.staffId
        });
    }
    onChange(state) {
        this.setState({
            search: state.search
        })
    }
    handleChange(e) {
        let search = e.target.value;
        attdAction.search(search);
    }

    handleSubmit() {

    }
    render() {
        let showAllBtn = "";

        showAllBtn = (
            <div className="">
                <Link to={'/staff'} className="btn btn-primary btn-sm">Show Employees/Team Attedance</Link>
            </div>
        );


        return (
            <div className="row atd-i">
                <form className="form-horizontal">
                    <div className="col-sm-4 atd-i-wp">
                        <label htmlFor="empName" className="col-xs-3 control-label">Employee: </label>

                        <div className="input-group input-group-sm">
                            <input type="text" className="form-control" id="empName" placeholder="Search Employee by Name or Id" value={this.state.search} onChange={this.handleChange} />
                            <span className="input-group-btn">
                                <button className="btn btn-default" type="button" onClick={this.handleSubmit}>Search</button>
                            </span>
                        </div>
                    </div>
                    <div className="col-sm-4 atd-i-wp">
                        {showAllBtn}
                    </div>
                </form>
            </div>

        );
    }
}
export default AttdFilter;


// WEBPACK FOOTER //
// ./app/components/attdComponents/attdFilter.js